import React
    from "react";
import {useTheme} from "@mui/material/styles";

const FormElement = ({
                         id,
                         label,
                         children,
                         className,
                         hiddenLabel = false,
                         required = false,
                         ...rest
                     }) => {
    let classNames = ["fz-form-element", className].filter(Boolean).join(" ").trim();

    return (
        <div className={classNames} {...rest}>
            {hiddenLabel === false && <label className='fz-form-field-label' htmlFor={id}>{label}{required === true ? " *" : ''}</label>}
            {children}
        </div>
    )
}

export default FormElement;